import { axiosGet } from '@/app/helpers/AxiosHelper';
export default {
    state: {
    },
  
    getters: {
    },
  
    mutations: {
    },
  
    actions: {
      postEmailAccess({commit}, data) {
        const url = `/accreditations/process/emailNotifyAccess/${data}`;
            axiosGet(url).then(res => {
            });
      },

      postEmailAccessAcc({commit}, data) {
        const url = `/accreditations/process/emailNotifyAccessAcc/${data}`;
            axiosGet(url).then(res => {
            });
      }
    }
  }
